export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const CONTACT_EMAIL = "contact@nzworks-jp";
export const TWEET_INTERVAL = 1000 * 60 * 60 * 24 * 14;